import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TestimonyComponent } from './testimony.component';


const routes: Routes = [
  {path: 'testimony', component: TestimonyComponent}
];
@NgModule({
  declarations: [],
  imports: [
    RouterModule,
    CommonModule
  ],
   exports: [RouterModule]
})
export class TestimonyRoutingModule { }
